import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  IconButton,
  Grid,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import axios from "axios";
import { baseUrl, config, requestID } from "../../common/utils";
import { useBusinessContext } from "../../context/business-context";
import { IonToast } from "@ionic/react";

type Props = {
  open: boolean;
  onClose: () => void;
  onGetactivationList?: () => void;
  branch: any | null;
  onBranchUpdated: () => void;
  setMessage: (message: string) => void;
  setShowToast: (showToast: boolean) => void;
};

const EditBranchModal = ({
  open,
  onClose,
  branch,
  onBranchUpdated,
  setMessage,
  setShowToast,
}: Props) => {
  const [loading, setLoading] = useState(false);
  const [branches, setBranches] = useState<any>({});

  const [updatedBranch, setUpdatedBranch] = useState(branch || {});
  const { selectedBusinessId } = useBusinessContext();

  useEffect(() => {
    if (branch) {
      setUpdatedBranch(branch);
    }
  }, [branch]);

  

  const handleUpdateBranch = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", selectedBusinessId);
      formData.append("branch_id", branch.branch_id);

      Object.keys(updatedBranch).forEach((key) => {
        if (key === "approvalChart" && Array.isArray(updatedBranch[key])) {
          updatedBranch[key].forEach((approvalItem, index) => {
            Object.keys(approvalItem).forEach((subKey) => {
              formData.append(
                `approvalChart[${index}][${subKey}]`,
                approvalItem[subKey]
              );
            });
          });
        } else {
          formData.append(key, updatedBranch[key]);
        }
      });
      const response = await axios.post(
        baseUrl() + "Businesss/editBranchs",
        formData,
        config
      );
      console.log({ response });
      onBranchUpdated();
      onClose();
      setMessage("Branch Updated Successfully");
    } catch (error) {
      console.error("Error updating branch:", error);
      setMessage("Error updating branch");
    } finally {
      setLoading(false);
      setShowToast(true);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setUpdatedBranch((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleApprovalChartChange = (e: any, index: number) => {
    const { name, value } = e.target;
  
    setUpdatedBranch((prev: any) => {
      if (!prev?.approvalChart || !Array.isArray(prev.approvalChart)) {
        console.warn("Approval chart is missing or not an array.");
        return prev; 
      }
  
      // Create a new array to trigger state update
      const updatedApprovalChart = [...prev.approvalChart];
  
      updatedApprovalChart[index] = {
        ...updatedApprovalChart[index],
        [name]: value, 
      };
  
      return { ...prev, approvalChart: updatedApprovalChart };
    });
  };




  const roleNames: Record<string, string> = {
    "1": "Member",
    "2": "Account",
    "3": "Audit",
    "4": "Chairman",
    "5": "Teller",
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxHeight: "90vh",
          width: 900,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          overflowY: "auto",
        }}
      >
        {/* Modal Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            variant="h6"
            sx={{ color: "chocolate", textTransform: "uppercase" }}
          >
            Edit {branch?.name}
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>

        {/* Form Grid */}
        <Grid container spacing={3}>
          {/* General Branch Fields */}
          {branch &&
            Object.keys(branch)
              .filter(
                (key) =>
                  key !== "id" &&
                  key !== "business_id" &&
                  key !== "branch_id" &&
                  key !== "approvalChart" &&
                  key !== "walletBalance"
              )
              .map((key, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <TextField
                    fullWidth
                    label={key.replace(/_/g, " ")} // Make labels more readable
                    name={key}
                    value={(updatedBranch as any)[key] || ""}
                    onChange={handleChange}
                    variant="outlined"
                  />
                </Grid>
              ))}

          {/* Approval Chart Fields */}
        </Grid>

        <Grid sx={{ my: 2, gap: 2 }}>
        {branch?.approvalChart?.map((item: any, index: number) => (
  <Grid container spacing={2} my={2} key={index} alignItems="center">
    <Grid item xs={3}>
      <TextField
        fullWidth
        label={`Amount Limit ${index + 1}`}
        name="amount"
        type="number"

        value={updatedBranch?.approvalChart?.[index]?.amount || ""}
        onChange={(e) => handleApprovalChartChange(e, index)}
        variant="outlined"
      />
    </Grid>
    <Grid item xs={3}>
      <TextField
        fullWidth
        label="Upper Limit"
        name="uplimit"
        type="number"
        value={updatedBranch?.approvalChart?.[index]?.uplimit || ""}
        onChange={(e) => handleApprovalChartChange(e, index)}
        variant="outlined"
      />
    </Grid>
    <Grid item xs={3}>
      <TextField
        fullWidth
        label="Lower Limit"
        name="downlimit"
        type="number"

        value={updatedBranch?.approvalChart?.[index]?.downlimit || ""}
        onChange={(e) => handleApprovalChartChange(e, index)}
        variant="outlined"
      />
    </Grid>
    <Grid item xs={3}>
      <TextField
        fullWidth
        label="Role"
        name="roleID"
        value={roleNames[item.roleID] || "Unknown"}
        variant="outlined"
        disabled
      />
    </Grid>
  </Grid>
))}
        </Grid>

        {/* Update Button */}
        <Button
          sx={{ mt: 3 }}
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleUpdateBranch}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update Branch"}
        </Button>
      </Box>
    </Modal>
  );
};

export default EditBranchModal;
